import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ButtonBase from '@mui/material/ButtonBase';

const StyledButtonBase = styled(ButtonBase)`
  &.ButtonBase-contents {
    display: contents;
  }
  &.ButtonBase-fullWidth {
    width: 100% !important;
  }
  &.ButtonBase-fullHeight {
    height: 100% !important;
  }
  
  ${ComponentStyles}
`;

StyledButtonBase.propTypes = {
  theme: PropTypes.object
};

export default StyledButtonBase;
